/* Stock limit on the quantity "+" button (added 15 Oct 2026).
   - Product page / quick view: "+" stops at stock on hand minus what is already in the cart.
   - Cart page and cart drawer: "+" stops at stock on hand.
   Only applies to items where Shopify tracks stock and "continue selling when out of stock" is off.
   Stock numbers come from the stock-caps section and the product-qty-input snippet. */
(function () {
  var cart = null; // { counts: {variantId: qty}, caps: {variantId: cap|null} }

  function inCart(id) { return (cart && cart.counts[id]) || 0; }

  function refreshButtons(qty) {
    if (qty && typeof qty.validateQtyRules === 'function') qty.validateQtyRules();
  }

  // Product page / quick view selector
  function applyProduct(qty, variantId) {
    var input = qty.querySelector('input[name="quantity"]');
    if (!input || !variantId) return;
    var map = {};
    try { map = JSON.parse(qty.dataset.stockMap || '{}'); } catch (e) {}
    var cap = map[variantId];
    var min = parseInt(input.min) || 1;
    var note = '';
    if (cap === null || cap === undefined) {
      input.removeAttribute('max');
      delete input.dataset.max;
    } else {
      var already = inCart(variantId);
      var left = Math.max(cap - already, min);
      input.max = left;
      input.dataset.max = left;
      if ((parseInt(input.value) || min) > left) input.value = left;
      if (already > 0 && cap - already <= 0) {
        note = 'All ' + cap + ' in stock are already in your cart.';
      } else if (already > 0) {
        note = already + ' already in your cart, ' + (cap - already) + ' more available.';
      }
    }
    showNote(qty, note);
    refreshButtons(qty);
  }

  // Small line under the quantity box explaining why "+" has stopped
  function showNote(qty, text) {
    var holder = qty.parentNode;
    if (!holder) return;
    var el = holder.querySelector('.stock-limit-note');
    if (!text) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('p');
      el.className = 'stock-limit-note';
      el.style.cssText = 'margin:6px 0 0;font-size:13px;line-height:1.4;opacity:.75;flex-basis:100%;';
      qty.insertAdjacentElement('afterend', el);
    }
    el.textContent = text;
  }

  function productVariant(qty) {
    var input = qty.querySelector('input[name="quantity"]');
    var formId = input && input.getAttribute('form');
    var form = formId && document.getElementById(formId);
    var idInput = form && form.querySelector('[name="id"]');
    return idInput && idInput.value;
  }

  // Cart page / drawer line
  function applyCartLine(input) {
    if (!cart || input.disabled) return;
    var id = input.dataset.quantityVariantId;
    if (!(id in cart.caps)) return;
    var cap = cart.caps[id];
    if (cap === null) return;
    var current = parseInt(input.value) || 0;
    var max = Math.max(cap, current, parseInt(input.min) || 1); // never shrink what is already in the cart
    if (!input.max || parseInt(input.max) > max) input.max = max;
    refreshButtons(input.closest('m-quantity-input'));
  }

  function applyWithin(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('m-quantity-input[data-stock-map]').forEach(function (qty) {
      applyProduct(qty, productVariant(qty));
    });
    root.querySelectorAll('m-quantity-input input[data-quantity-variant-id]').forEach(applyCartLine);
  }

  function refreshCart() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart?section_id=stock-caps', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-stock-caps]');
        var items = JSON.parse(el.textContent).items || [];
        var next = { counts: {}, caps: {} };
        items.forEach(function (it) {
          next.counts[it.v] = (next.counts[it.v] || 0) + it.q;
          next.caps[it.v] = it.cap;
        });
        cart = next;
        applyWithin(document);
      })
      .catch(function () {
        if (!cart) cart = { counts: {}, caps: {} };
        applyWithin(document);
      });
  }

  // Shopper picks another colour/size: the theme updates the hidden variant id and fires "change".
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== 'id' || !t.form || !t.form.id) return;
    document.querySelectorAll('m-quantity-input[data-stock-map] input[form="' + t.form.id + '"]').forEach(function (input) {
      applyProduct(input.closest('m-quantity-input'), t.value);
    });
  }, true);

  // Typed-in quantities above the limit drop back to the limit straight away.
  function clampTyped(e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('m-quantity-input input[type="number"]') || !t.max) return;
    var max = parseInt(t.max);
    if ((parseInt(t.value) || 0) > max) {
      t.value = max;
      refreshButtons(t.closest('m-quantity-input'));
    }
  }
  document.addEventListener('input', clampTyped, true);
  document.addEventListener('change', clampTyped, true);

  // The cart drawer, cart page and quick view replace their HTML after updates.
  new MutationObserver(function (records) {
    records.forEach(function (r) {
      r.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches('m-quantity-input')) applyWithin(n.parentNode);
        else if (n.querySelector('m-quantity-input')) applyWithin(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  function start() {
    if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, refreshCart);
    }
    applyWithin(document);
    refreshCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
